/// <amd-module name="Widgets/CodeScalarWidget/CodeScalarWidgetTfvcRestClient" />
import { RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import { TfvcChangesetRef, TfvcChangesetSearchCriteria } from "VC/Common/Contracts/Git";
/**
 * TODO — Switch to the official auto-generated rest API
 *
 * The Tfvc client does not support custom / named / complex parameters
 *
 *     Bug 1466234: Tfvc , Git typescript client getChangesets/getCommits API does not consider searchCriteria parameters . For git we have a workaround using getCommitsBatch , for Tfvc we have to use this client
 */
export class CodeScalarWidgetTfvcRestClient extends RestClientBase {
    /**
     * Retrieve Tfvc Changesets
     *
     * @param {string} project - Project ID or project name
     * @param {TfvcChangesetSearchCriteria} searchCriteria - Following criteria available (.itemPath, .version, .versionType, .versionOption, .author, .fromId, .toId, .fromDate, .toDate) Default: null
     * @return Promise<TfvcChangesetRef[]>
     */
    public async getChangesets(project: string, searchCriteria: TfvcChangesetSearchCriteria): Promise<TfvcChangesetRef[]> {
        const queryValues: any = {
            "searchCriteria.itemPath": searchCriteria.itemPath,
            "searchCriteria.fromDate": searchCriteria.fromDate
        };

        return this.beginRequest<TfvcChangesetRef[]>({
            apiVersion: "5.0",
            routeTemplate: "{project}/_apis/tfvc/changesets/{id}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }
}

RestClients.add("CodeScalarWidgetTfvcRestClient", {
    factory: CodeScalarWidgetTfvcRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
